/**
 * Cosimo Logo Component
 *
 * Simple logo component using the shared SVG from the public directory.
 * Default render size keeps the asset's aspect ratio in the navbar.
 */
"use client";

import Image from "next/image";

interface CosimoLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function CosimoLogo({ className = "", width = 58, height = 14 }: CosimoLogoProps) {
  return (
    <Image
      src="/logo.svg"
      alt="Cosimo"
      width={width}
      height={height}
      className={className}
      priority
    />
  );
}
